var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3125 0.5H11.6875C14.6211 0.5 17 2.87894 17 5.8125V12.1875C17 15.1211 14.6211 17.5 11.6875 17.5H5.3125C2.37894 17.5 0 15.1211 0 12.1875V5.8125C0 2.87894 2.37894 0.5 5.3125 0.5ZM11.6875 15.9062C13.7381 15.9062 15.4062 14.2381 15.4062 12.1875V5.8125C15.4062 3.76187 13.7381 2.09375 11.6875 2.09375H5.3125C3.26187 2.09375 1.59375 3.76187 1.59375 5.8125V12.1875C1.59375 14.2381 3.26187 15.9062 5.3125 15.9062H11.6875Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 9C4.25 6.65294 6.15294 4.75 8.5 4.75C10.8471 4.75 12.75 6.65294 12.75 9C12.75 11.3471 10.8471 13.25 8.5 13.25C6.15294 13.25 4.25 11.3471 4.25 9ZM5.84375 9C5.84375 10.4641 7.03588 11.6562 8.5 11.6562C9.96412 11.6562 11.1562 10.4641 11.1562 9C11.1562 7.53481 9.96412 6.34375 8.5 6.34375C7.03588 6.34375 5.84375 7.53481 5.84375 9Z",
    fill: "#263238"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0689,
    cy: 4.43106,
    r: 0.566312,
    fill: "#263238"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.375870ecdf58125b80c3c8cc00c84ad5.svg";
export { ForwardRef as ReactComponent };